<template>
  <div class="fileUploaderMain">
    <el-button type="primary" size="small" @click="upload">选择文件</el-button>
    <input ref="uploadFile" type="file" style="display: none;" @change="_handleChange" />

    <div v-if="backFileList && backFileList.length" class="fileBox">
      <div
        class="fileDiv"
        v-for="(item, index) in backFileList"
        :key="index"
        @mouseenter="closeAppear(index)"
        @mouseleave="closeDisapear(index)"
      >
        <span>
          <a
            :href="downloadUrl + item"
            target="_self"
          >{{item.split('/')[item.split('/').length -1]}}</a>
        </span>
        <i
          v-if="newArray[index]"
          class="el-icon-error"
          style="font-size: 18px;padding: 0 5px;"
          @click="_delFromServer(index)"
        ></i>
      </div>
    </div>

    <div v-else class="fileBox">
      <div
        class="fileDiv"
        v-for="(file, i) in fileList"
        :key="i"
        @mouseenter="closeAppear(i)"
        @mouseleave="closeDisapear(i)"
      >
        <span>
          <a :href="fileUrl" target="_self" :title="file.name">{{file.name}}</a>
        </span>
        <i
          v-if="!newArray[i]"
          class="el-icon-circle-check"
          style="color: green;font-size: 18px;padding: 0 5px;"
        ></i>
        <i
          v-else
          class="el-icon-circle-close"
          style="font-size: 18px;padding: 0 5px;"
          @click="delFile(i)"
        ></i>
      </div>
    </div>
  </div>
</template>

<script>
import { getFileURL } from '../utils/utils'
import config from '../config'

const { downloadUrl } = config
export default {
  name: 'fileUploader',
  props: [
    'fileList',
    'handleChange',
    'backFileList',
    'delFromServer',
    'level_id'
  ],
  data () {
    return {
      downloadUrl,
      newArray: [],
      fileUrl: '', // 文件路径
      fileName: '' // 文件名
    }
  },
  methods: {
    getFileURL,
    upload () {
      this.$refs.uploadFile.click()
    },
    _handleChange (e) {
      this.file = e.target.files[0]
      this.fileName = this.file.name
      this.fileUrl = this.getFileURL(this.file)
      this.handleChange(this.file)
    },
    delFile (index) {
      this.$confirm('确定删除该文件吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.fileList.splice(index, 1)
        this.$refs.uploadFile.value = null
      })
    },
    // 从服务器删除文件
    _delFromServer (index) {
      this.delFromServer(index)
    },
    closeAppear (i) {
      this.$set(this.newArray, i, true)
    },
    closeDisapear (i) {
      this.$set(this.newArray, i, false)
    }
  }
}
</script>

<style lang="scss">
.fileUploaderMain {
  .fileBox {
    margin: 20px 0;
    width: 250px;
    min-height: 100px;
    overflow: scroll;
    .fileDiv {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .el-icon-circle-close:hover {
        cursor: pointer;
      }
    }
    .fileDiv:hover {
      background: #e4e7ed;
    }
  }
}
</style>
